import { IconButtonProps } from '@rjsf/utils';
import { Trash2 } from 'lucide-react';
import { Button } from '../../Button';

export const ShRemoveButton = (props: IconButtonProps) => (
  <Button
    variant="destructive"
    size="sm"
    onClick={props.onClick}
    disabled={props.disabled}
    className="ml-1"
  >
    <Trash2 className="ml-2 h-4 w-4" />
    Remove
  </Button>
);
